import { render } from "./AppLoadingButton.vue?vue&type=template&id=0a1243c1&scoped=true&ts=true"
import script from "./AppLoadingButton.vue?vue&type=script&lang=ts"
export * from "./AppLoadingButton.vue?vue&type=script&lang=ts"

import "./AppLoadingButton.vue?vue&type=style&index=0&id=0a1243c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1243c1"]])

export default __exports__